var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"c-link",attrs:{"href":_vm.linkUrl,"target":_vm.targetBlank ? '_blank' : '_self'}},[_vm._v(_vm._s(_vm.linkText))])}
var staticRenderFns = []

export { render, staticRenderFns }